import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet';

const AGBContainer = styled.div`
  min-height: 100vh;
  padding-top: 100px;
`;

const HeroSection = styled.section`
  position: relative;
  height: 20vh;
  background: ${props => props.theme.colors.gradients.hero};
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  overflow: hidden;
`;

const HeroContent = styled.div`
  text-align: center;
  max-width: 800px;
  padding: 0 2rem;
  z-index: 2;
`;

const HeroTitle = styled(motion.h1)`
  font-family: ${props => props.theme.fonts.script};
  font-size: clamp(2.5rem, 5vw, 3.5rem);
  font-weight: 700;
  margin-bottom: 1rem;
  text-shadow: 3px 3px 6px rgba(0, 0, 0, 0.4);
`;

const ContentSection = styled.section`
  padding: 4rem 0;
  background: ${props => props.theme.colors.backgroundLight};
`;

const Container = styled.div`
  max-width: 900px;
  margin: 0 auto;
  padding: 0 2rem;
`;

const ContentCard = styled(motion.div)`
  background: white;
  border-radius: 20px;
  padding: 2.5rem;
  box-shadow: ${props => props.theme.shadows.card};
  margin-bottom: 2rem;
  
  h2 {
    color: ${props => props.theme.colors.primary};
    font-size: 1.8rem;
    margin-bottom: 1.5rem;
    font-weight: 600;
  }
  
  p {
    line-height: 1.8;
    color: ${props => props.theme.colors.textLight};
    margin-bottom: 1.5rem;
    
    strong {
      color: ${props => props.theme.colors.text};
      font-weight: 600;
    }
  }
`;

const AGB = () => {
  return (
    <AGBContainer>
      <Helmet>
        <title>Allgemeine Geschäftsbedingungen (AGB) - Der Ponystall | Marcella Deeken</title>
        <meta name="description" content="Allgemeine Geschäftsbedingungen von Der Ponystall - Marcella Deeken für tiergestützte Pädagogik und Förderung." />
      </Helmet>

      <HeroSection>
        <HeroContent>
          <HeroTitle
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
          >
            Allgemeine Geschäftsbedingungen
          </HeroTitle>
        </HeroContent>
      </HeroSection>

      <ContentSection>
        <Container>
          <ContentCard
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <h2>Geltungsbereich</h2>
            <p>
              Diese AGB gelten für alle Angebote und Leistungen von <strong>Der Ponystall – Marcella Deeken</strong>.
            </p>
          </ContentCard>

          <ContentCard
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            <h2>Anmeldung und Vertragsschluss</h2>
            <p>
              Die Buchung erfolgt online oder per E-Mail und stellt ein verbindliches Angebot dar. Der
              Vertrag kommt mit unserer Bestätigung zustande.
            </p>
          </ContentCard>

          <ContentCard
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.6 }}
          >
            <h2>Zahlung</h2>
            <p>
              Zahlungen werden über unseren Zahlungsdienstleister <strong>Stripe</strong> abgewickelt. Sofern nicht anders
              vereinbart, ist die Gebühr vor Beginn der Leistung fällig.
            </p>
          </ContentCard>

          <ContentCard
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.8 }}
          >
            <h2>Stornierung</h2>
            <p>
              Stornierungen sind bis <strong>24 Stunden vor Terminbeginn</strong> kostenfrei möglich. Danach kann die
              Gebühr ganz oder teilweise einbehalten werden.
            </p>
          </ContentCard>

          <ContentCard
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 1.0 }}
          >
            <h2>Haftung</h2>
            <p>
              Die Teilnahme erfolgt auf eigenes Risiko. Es besteht eine Haftpflichtversicherung im Rahmen
              der gesetzlichen Bestimmungen. Für Schäden, die durch grobe Fahrlässigkeit oder Vorsatz
              entstehen, haften wir nach den gesetzlichen Vorschriften.
            </p>
          </ContentCard>

          <ContentCard
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 1.2 }}
          >
            <h2>Schlussbestimmungen</h2>
            <p>
              Es gilt deutsches Recht. Gerichtsstand ist – soweit zulässig – unser Geschäftssitz.
            </p>
          </ContentCard>
        </Container>
      </ContentSection>
    </AGBContainer>
  );
};

export default AGB;


